import { IPageLevelExperimentConfig } from '../pageExperiments.types'

import PAGE_EXPERIMENTS_DEFINITION from './pageExperiments'

const PAGE_EXPERIMENTS_CONFIG_LIST = [
  {
    name: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.name,
    pageExpCookie: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.pageExpCookie,
    buckets: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets,
    version: 'v1',
    pages: ['/', '/new-home-page', '/New-home-design'],
    bucketsDistribution: [
      {
        name: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.control,
        ratio: 90,
      },
      {
        name: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.show1,
        ratio: 5,
      },
      {
        name: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.show2,
        ratio: 5,
      },
    ],
    bucketToSlugs: {
      [PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.control]: ['/'],
      [PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.show1]: ['/new-home-page'],
      [PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.show2]: ['/New-home-design'],
    },
    defaultBucket: PAGE_EXPERIMENTS_DEFINITION.NEW_HOME_PAGE.buckets.control,
  },
] satisfies IPageLevelExperimentConfig[]

Object.freeze(PAGE_EXPERIMENTS_CONFIG_LIST)

export default PAGE_EXPERIMENTS_CONFIG_LIST
